import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export type GettingStartedCardProps = Record<string, never>
export const GettingStartedCardPrivate = ({}: GettingStartedCardProps) => {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Getting Started</CardTitle>
          <CardDescription>
            Follow these steps to set up React Native Google Sign-In
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
              <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-sm">
                1
              </div>
              <div className="min-w-0">
                <p className="font-medium text-base">Purchase a License</p>
                <p className="text-sm text-muted-foreground">
                  Purchase a subscription, if you haven't done so already.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
              <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-sm">
                2
              </div>
              <div className="min-w-0">
                <p className="font-medium text-base">Invite GitHub Users</p>
                <p className="text-sm text-muted-foreground">
                  Invite GitHub users to our private repository using the "Manage this subscription"
                  button. That way they get access to the npm package as well as the sources.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
              <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-xs sm:text-sm">
                3
              </div>
              <div className="min-w-0">
                <p className="font-medium text-base">Install the npm Package</p>
                <p className="text-sm text-muted-foreground">
                  Follow the{' '}
                  <a
                    href="https://react-native-google-signin.github.io/docs/install"
                    className="text-primary hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    installation instructions
                  </a>{' '}
                  for{' '}
                  <a
                    href="https://react-native-google-signin.github.io/docs/one-tap"
                    className="text-primary hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Universal sign-in.
                  </a>
                </p>
              </div>
            </div>
            <div className="flex items-start gap-2.5 p-2.5 sm:p-3">
              <div className="flex h-5 w-5 sm:h-6 sm:w-6 shrink-0 items-center justify-center rounded-full bg-foreground text-background font-semibold text-xs sm:text-sm">
                4
              </div>
              <div className="min-w-0">
                <p className="font-medium text-base">Complete the Setup</p>
                <p className="text-sm text-muted-foreground">
                  Integrate{' '}
                  <a
                    href="https://react-native-google-signin.github.io/docs/category/setting-up"
                    className="text-primary hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Universal sign-in
                  </a>{' '}
                  in your app! 🚀
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  )
}
